import React from "react";
import { motion } from "framer-motion";
import "../../components/Blog/Blog.css";
import BlogImage1 from '../../assets/images/blog1.png';
import BlogImage2 from '../../assets/images/blog2.png';
import BlogImage3 from '../../assets/images/blog3.png';
import BlogImage4 from '../../assets/images/blog4.png';
import '../../styles/CustomClassCss/Custom.css';
import { useNavigate } from "react-router-dom";

const Blog = () => {
	const navigate = useNavigate();

	const blogPosts = [
		{
			title: "Reasons to Invest in the Steel Industry",
			category: "by stelmart",
			date: "Jan 10, 2025",
			image: BlogImage3,
			description: "Steel is a major component of contemporary life, and it supports very well in various key sectors including automotive, construction , and transport."
		},
		{
			title: "What StelMart Offers to Its Buyers?",
			category: "by stelmart",
			date: "Jan 8, 2025",
			image: BlogImage4,
			description: "StelMart is a digital platform that connects buyers, sellers, and financial institutions revolutionizing the steel market."
		},
		{
			title: "Latest Developments for Sellers in the Steel and Polymer Industries",
			category: "by stelmart",
			date: "Jan 7, 2025",
			image: BlogImage2,
			description: "The steel and polymer industries have supported transformation to give sellers more accuracy and efficiency in day-to-day operations."
		},
		{
			title: "What Makes StelMart Stand Out from the Competition?",
			category: "by stelmart",
			date: "Jan 6, 2025",
			image: BlogImage1,
			description: "Online shopping has become a very common mode of shopping in India. Many e-commerce websites offer the best products, prices , and services."
		},
	];

	const truncateToWordLimit = (text, limit) => {
		const words = text.split(" ");
		if (words.length > limit) {
			return words.slice(0, limit).join(" ") + "...";
		}
		return text;
	};

	const sortedBlogPosts = blogPosts.sort((a, b) => new Date(b.date) - new Date(a.date));

	const contentVariant = {
		hidden: { opacity: 0, y: 50 },
		visible: {
			opacity: 1,
			y: 0,
			transition: { duration: 1.2, ease: "easeInOut" },
		},
	};

	const imageVariant = {
		hidden: { opacity: 0, y: 50 },
		visible: {
			opacity: 1,
			y: 0,
			transition: { duration: 1.2, ease: "easeInOut" },
		},
	};

	// const handleClick = (post) => {
	// 	navigate("/blog-details", { state: post });
	// };

	return (
		<div className="blogs-section custom-inner-space custom-container-upper">
			<div className="team-header">
				<h2 className="meet-top font-poppins">Blogs</h2>
				{/* <a href="#" className="view-all">
          VIEW ALL
        </a> */}
			</div>

			<motion.div
				className="blogs-grid"
				initial="hidden"
				whileInView="visible"
				viewport={{ once: true, amount: 0.2 }}
			>
				{sortedBlogPosts.map((post, index) => (
					<motion.div
						key={index}
						className="blog-post"
						variants={contentVariant}
					// onClick={() => handleClick(post)}

					>
						<motion.div className="blog-image" variants={imageVariant}>
							<img src={post.image} alt={post.title} />
						</motion.div>
						<div className="blog-info">
							<span className="category font-rubik">{post.category}</span>
							<span className="date font-rubik">• {post.date}</span>
						</div>
						<h3 className="blog-title font-merriweather">{post.title}</h3>
						<p className="blog-description font-poppins">{truncateToWordLimit(post.description, 20)}</p>
					</motion.div>
				))}
			</motion.div>
		</div>
	);
};

export default Blog;
